"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const TrialsResultsMainIntro_vue_1 = __importDefault(require("../TrialsResultsMainIntro.vue"));
const TrialsResultsMainTopAction_vue_1 = __importDefault(require("../TrialsResultsMainTopAction.vue"));
const SummaryMetrics_vue_1 = __importDefault(require("@becrop/components/TrialsSummary/SummaryMetrics.vue"));
const TableSummaryLegendStars_vue_1 = __importDefault(require("@becrop/components/Results/Projects/TableSummaryLegendStars.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const floating_vue_1 = require("floating-vue");
const LegendStars_vue_1 = __importDefault(require("@becrop/components/Results/Projects/LegendStars.vue"));
let TrialsSummary = class TrialsSummary extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get trialId() {
        const url = window.location.href;
        const match = url.match(/\/trials\/(\d+)/);
        if (match) {
            const trialNumber = match[1];
            return trialNumber;
        }
        else {
            console.log('No se encontró el id del trials');
        }
    }
    showSummaryTableWithMetric(metric) {
        this.$emit('showSummaryTableWithMetric', metric);
    }
    dwGlobalReport(id) {
        window.open(`/trials/summary/report/${id}`);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], TrialsSummary.prototype, "summaryGlobalData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TrialsSummary.prototype, "fetchingSummaryTable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TrialsSummary.prototype, "summaryGlobalHasMetrics", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TrialsSummary.prototype, "theme", void 0);
TrialsSummary = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TrialsResultsMainIntro: TrialsResultsMainIntro_vue_1.default,
            TrialsResultsMainTopAction: TrialsResultsMainTopAction_vue_1.default,
            TableSummaryLegendStars: TableSummaryLegendStars_vue_1.default,
            SummaryMetrics: SummaryMetrics_vue_1.default,
            ViewZero: bmk_ui_framework_1.ViewZero,
            Link: bmk_ui_framework_1.Link,
            Button: bmk_ui_framework_1.Button,
            Download: lucide_vue_next_1.Download,
            Dropdown: floating_vue_1.Dropdown,
            LegendStars: LegendStars_vue_1.default,
        },
    })
], TrialsSummary);
exports.default = TrialsSummary;
